<div
  [class]="styleClass"
  [ngClass]="{ 'cre-expandable-panel': 'true', 'cre-expandable-panel-card': cardType }"
>
  <span class="cre-expandable-panel-header" *ngIf="isHeaderConfigured">
    {{ header }}
  </span>
  <ng-content></ng-content>
  <div class="cre-expandable-panel-toggler" (click)="toggleExpand()" *ngIf="isExpandable">
    <div
      class="cre-expandable-panel-toggler-icon"
      [ngClass]="{ 'cre-expandable-panel-expanded': expanded }"
    ></div>
  </div>
</div>
